"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sushi = void 0;
exports.sushi = {
    minichef: '0xF4d73326C13a4Fc5FD7A064217e12780e9Bd62c3',
    router: '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506', // UniswapV2Router02
};
